import { render, staticRenderFns } from "./persona-update.vue?vue&type=template&id=3bd2770d&"
import script from "./persona-update.component.ts?vue&type=script&lang=ts&"
export * from "./persona-update.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports